enum Mutation {
  SET_SETTINGS = 'setSettings',
  SET_EMPLOYMENT_ID = 'setEmploymentId',
  PATCH_SETTINGS_STATE = 'patchSharedSettings',
  SET_IS_READY = 'setIsReady',
}

export default Mutation;
